<template>
  <tr v-if="value !== null && value !== undefined" class="loggerDetails">
    <th scope="row">{{ $t(`${labelName}`) }}</th>
    <td>{{ value }}</td>
  </tr>
</template>

<script>
export default {
  name: 'LoggerDetails',
  props: {
    value: { type: [String, Number, Boolean], default: null },
    labelName: { type: String, default: '' }
  }
}
</script>

<style lang="css">
tr.loggerDetails {
  white-space: normal;
  text-align: left;
  font-size: 10px;
  table-layout: fixed;
  border-collapse: collapse;
  font-family: sans-serif;
}

.loggerDetails th {
  padding: 3px;
  background-color: #ddd;
}

.loggerDetails td {
  word-break: break-word;
  text-align: center;
  background-color: #eee;
}
</style>
